import React from 'react';
import './App.css';
import Slider from './components/slider';

function App() {
	return (
		<div className="App">
			<header className="App-header">
				<Slider />
			</header>
		</div>
	);
}

export default App;
